import {apiGet} from "./api";

export const getLogReports = async (data) => {
    return await apiGet('log-reports', data);
}
export const getLogReportsAdmin = async (data) => {
    return await apiGet('log-admin-reports', data);
}
